/* eslint-disable */
var $ = window.jQuery = require('jquery');

import {bus} from '@/main';
import carousel from 'vue-owl-carousel'
import {mapGetters} from 'vuex';
import staff from '@/assets/images/icon/staff.png';
import toast from '@/services/toast';

export default {
  name: 'course-list',
  components: {
    carousel
  },
  data() {
    return {
      courses:null,
      courseListResults: [],
      categoryList: {},
      categoryFilterName: 'Select Category',
      id: '',
      loader: false,
      deleteCourseId: '',
      isRoleIn:'',
      sliderTouchDrag:false,
      staff:staff
    }
  },
  computed: {
    ...mapGetters([
      'getlastestCoursesState',
      'getCategoryListState',
      'getCourseByCategoryState',
    ]),
    getCategory() {
      this.categoryList = this.$store.getters.getCategoryListState;
      return this.categoryList
    },
    getAllCourses() {
      this.$store.dispatch('getcourselist')
        .then((res) => {
          if (res.data.code == '2000') {
            return this.courses = this.$store.getters.getlastestCoursesState.data
          }
        })
        .catch((err) => {})
    },
    SetIntialStatus() {
      if (this.courses) {
        this.courseListResults = this.courses.results

      }
    },
    getUserDetails() {
      this.$store.dispatch('getUserRoleDetails').then((res) => {
        this.isRoleIn = res.data.data.profile.role
      }).catch((err) => {})
    }
  },
  mounted() {
    this.getCategory
    this.getAllCourses
    this.SetIntialStatus
    this.getUserDetails
  },
  methods: {
    getCourseDetailsAgain() {
      this.loader = true;
      this.$store.dispatch('getcourselist').then((res) => {
        if (res.data.code == '2000') {
          this.loader = false;
          return this.courses = this.$store.getters.getlastestCoursesState.data
        }
      }).catch((err) => {})
    },
    viewCourseDetailsFun(id) {
      this.$router.push('/course/' + id + "/tab/")
      return this.courses = this.$store.getters.getlastestCoursesState.data;
    },
    getCoursebyCategory(id, name) {
      this.loader = true;
      if (id != "") {
        this.$router.push('/usercourses/category/' + id + "/")
      } else {
        this.$router.push('/courses/')
        this.loader = false;
      }
      this.categoryFilterName = name;
    },
    deleteCourseFun(id) {
      this.deleteCourseId = id
      $('#removeCourseModal').modal()
    },
    removeCourseModalConfirmation() {
      let data = {
        id: this.deleteCourseId
      }
      this.$store.dispatch('removeCourseFun', data)
        .then((res) => {
          if (res.status == '200' || res.status == '202') {
            this.getCourseDetailsAgain()
            toast.success(res.data.msg);
          }
        })
        .catch((err) => {})
    }
  },
  beforeMount() {
    this.getAllCourses
  },
  watch: {
    getCategory() {
      return this.$store.getters.getCategoryListState
    },
    getAllCourses() {
      return this.$store.getters.getlastestCoursesState;
    },
    SetIntialStatus() {
      if (this.courses) {
        this.courseListResults = this.courses.results
      }
    }
  }
}